import React from 'react';
import { Text } from '@chakra-ui/react';

const Header = () => {
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        Homework Help
      </Text>
    </>
  );
};

export default Header;
